import { useState } from "react";
import ShellCard from "../../components/ShellCard";
import slide1Img from "@/assets/images/slide-1.jpg";
import PackageCard from "../../components/PackageCard";

const packages = [
    {
        id: 1,
        titleLines: ["Driver Education", "Traffic Safety (DETS)", "course"],
        price: "$34.95",
        description: (
            <>
                <p>
                    The Driver Education Traffic Safety (DETS) course is required to get your license. (For New Drivers 14-17 years only).
                </p>
            </>
        ),
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIwNQ==",
    },
    {
        id: 2,
        titleLines: ["Florida Permit", "Practice", "Test"],
        price: "$19.95",
        description: (
            <>
                <p>Practice Exam for Florida DMV Permit</p>
            </>
        ),
        infoLink: "prep-course",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE1",
    },
    {
        id: 3,
        titleLines: ["Florida", "Permit", "Test"],
        price: "$24.95",
        description: (
            <>
                <p>Florida Driver's License Permit Exam</p>
            </>
        ),
        infoLink: "florida-driving-test",
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg1",
    },
    {
        id: 4,
        titleLines: ["Save", "more", "Package"],
        price: "$52.90",
        description: (
            <>
                <p>Driver Education Traffic Safety (DETS) + Florida DMV Permit Exam</p>
                <p className="fw-bold text-warning">SAVE $7.00 – 16%!</p>
            </>
        ),
        registerLink: "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=MzIwNg==",
    },
    {
        id: 5,
        titleLines: ["Complete", "Package with", "Practice Exam"],
        price: "$64.90",
        description: (
            <>
                <p>Driver Education Traffic Safety (DETS) course + Permit Practice Test + Florida DMV Permit Exam</p>
                <p className="fw-bold text-warning">SAVE $14.95 – 25%!</p>
            </>
        ),
        registerLink: "http://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=MzIwOA==",
    },
];

const DetsCourse = () => {
    const [hoveredCardId, setHoveredCardId] = useState(null);

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${slide1Img})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title mb-2">Driver Education Traffic Safety (DETS) course</h1>
                            <p className="banner-subheading fs-4">
                                Effective July 1, 2025
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <main className="dets-course-page text-white">
                <div className="container py-5">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <h3 className="section-title mb-4 text-warning">Course Details</h3>
                                <p className="mb-4">
                                    The new mandatory course for new drivers ages 14-17 is called the Driver Education Traffic Safety (DETS) course. Are you a teen or first-time driver in Florida ready to hit the road? Our state-approved Florida Online Driver’s Education Course is the easiest, fastest, and most flexible way to meet your learner’s permit requirements—without ever stepping foot in a classroom.
                                </p>

                                <h4 className="section-title mb-4 text-warning">Why Choose Our Online Course?</h4>
                                <ul className="text-white ps-3" style={{ listStyleType: "disc" }}>
                                    <li className="mb-2">State-Approved by the Florida DHSMV</li>
                                    <li className="mb-2">Accessible 24/7 on any device – study at your own pace</li>
                                    <li className="mb-2">Interactive lessons, videos, and quizzes to keep you engaged</li>
                                    <li className="mb-2">Automatic progress tracking – pick up right where you left off</li>
                                    <li className="mb-2">Completion certificate sent directly to the DMV offices</li>
                                    <li className="mb-2">Excellent customer support if you ever need help</li>
                                </ul>
                            </ShellCard>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center mb-5">
                        {packages.map((pkg) => (
                            <div key={pkg.id} className="col-12 col-md-6 col-lg-4 col-xl-2-4" style={{ minWidth: '220px' }}>
                                <PackageCard
                                    pkg={pkg}
                                    hoveredCardId={hoveredCardId}
                                    setHoveredCardId={setHoveredCardId}
                                    registerText="Register"
                                    moreInfoText="(More Info)"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <h3 className="section-title mb-4 text-warning">FAQ</h3>
                                <div className="accordion" id="faqAccordion">
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button bg-accordion text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Who is required to take this new drivers education course?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Any new driver in the state of Florida that is ages 14, 15, 16 and 17 years old must take this new Driver Education Traffic Safety (DETS) course
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Do I still need to take the 4-hour First Time Driver course (TLSAE)?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                No. The 4-hour First Time Driver course (TLSAE) is only for new drivers 18 years and older.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingThree">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Is the course offered online?
                                            </button>
                                        </h2>
                                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes. You can register and take the course online.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item bg-accordion border-secondary text-white">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button className="accordion-button collapsed bg-accordion text-white border-bottom border-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                When I complete the course is everything reported to the DMV offices?
                                            </button>
                                        </h2>
                                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes. Upon successful completion we automatically report your completion to the DMV offices.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>

                    {/* Who Needs This Course, What's Included, How It Works */}
                    <div className="row g-4">
                        <div className="col-12">
                            <ShellCard>
                                <div className="mb-4">
                                    <h4 className="section-title text-warning">Who Needs This Course?</h4>
                                    <p>
                                        If you are ages 14, 15, 16 or 17 years old in Florida, you must complete a Driver Education Traffic Safety (DETS) course before you can get your learner’s permit.
                                    </p>
                                    <p className="fw-bold">
                                        Effective July 1, 2025 new drivers aged 14-17 must take the Driver Education Traffic Safety (DETS) course.
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h4 className="section-title text-warning">What’s Included in the Course?</h4>
                                    <p>The Florida Department of Education (DOE) has listed some of the course topics below:</p>
                                    <ul className="text-white ps-3" style={{ listStyleType: "disc" }}>
                                        <li>Meaning and responsibilities of a Driver License</li>
                                        <li>Laws that govern the operation of a motor vehicle</li>
                                        <li>Knowledge of Florida’s Graduated Driver Licensing (GDL) laws</li>
                                        <li>Vehicle control and traffic procedures</li>
                                        <li>Knowledge of sharing the road with other types of vehicles and vulnerable road users</li>
                                        <li>Defensive driving strategies</li>
                                        <li>Physical and mental factors that affect driving ability</li>
                                        <li>Effects of alcohol and other drugs on driving performance</li>
                                    </ul>
                                </div>

                                <div className="mb-4">
                                    <h4 className="section-title text-warning">How It Works</h4>
                                    <ol className="text-white ps-3" style={{ listStyleType: "decimal" }}>
                                        <li>Sign Up in just a few minutes</li>
                                        <li>Complete the course at your own pace</li>
                                        <li>Pass the final quiz – unlimited free retakes if needed</li>
                                        <li>Certificate of Completion - Auto reported online to the DMV offices</li>
                                    </ol>
                                </div>

                                <div className="text-start mb-4">
                                    <h4 className="section-title text-warning">Get on the Road with Confidence</h4>
                                    <p>
                                        We make driver’s ed simple, convenient, and affordable. Whether you're a teenager getting your learner's permit or an adult looking for a refresher, our course is designed to get you safely and legally behind the wheel—fast.
                                    </p>
                                </div>
                                <div className="row text-center">
                                    <div className="col-12">
                                        <h5 className="fw-bold text-warning mt-4">Sign Up Today and Start Driving Toward Freedom!</h5>

                                        <a href="#" className="my-3 btn metro-btn-primary btn-lg fw-bold">Enroll Now</a>
                                        <p className="mt-2 text-white">It only takes a few minutes to get started!</p>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>

                    {/* Final CTA */}

                </div>
            </main>
        </>
    );
};

export default DetsCourse;
